module.exports = __webpack_public_path__ + "img/ykdx-logo2.42099f47.png";